<div class="container no-pad-top no-pad-h">
	<h3 class="title-h3 ">
		{{'bookingPayment.title.bankTransferPayment' | ibeadmin | async}}
	</h3>
	
	<ng-container *ngIf="bankTransferInfo">
		<section class="payment-step-section" attr.aria-label="{{'bookingPayment.label.firstStepPaymentDetails' | ibeadmin | async}}">
		
			<h5 class="title-h5 uppercase">
				1. {{'bookingPayment.text.transfer' | ibeadmin | async}}
			</h5>
			<p>
				{{'bookingPayment.text.transferTheAmountOf' | ibeadmin | async}} 
				<span class="bold"> {{ INDRA_cashPrice() | indracurrency }} </span> 
				{{'bookingPayment.text.throughTheFollowingData' | ibeadmin | async}}:
			</p>
		
			<ng-container *ngIf="market === 'MZ' || market === 'MA'">
				<div class="transfer-accounts__wrapper">
					<article class="payment-method-block" tabindex="0" *ngIf="bankTransferInfo.bankTransferDetails.length > 0 && bankTransferInfo.bankTransferDetails[0]"
						attr.aria-label="{{'bookingPayment.label.transferAccountDetails' | ibeadmin | async}}">
						<div class="payment-method-block__body">
							<div class="payment-method-block__right">
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.bank' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].name }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.accountNumber' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].accountNumber }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.iban' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].iban }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.nationalTransfers' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].nib }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.swift' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].swift }}
								</div>
							</div>
						</div>
					</article>
					<!--
					<div class="vertical-divider" aria-hidden="true" *ngIf="bankTransferInfo.bankTransferDetails.length > 0 && bankTransferInfo.bankTransferDetails[1]">
						<span class="vertical-divider__label">{{'bookingPayment.text.or' | ibeadmin | async}}</span>
					</div>
					<article class="payment-method-block" tabindex="0" *ngIf="bankTransferInfo.bankTransferDetails.length > 0 && bankTransferInfo.bankTransferDetails[1]"
						attr.aria-label="{{'bookingPayment.label.transferAccountDetails' | ibeadmin | async}}">
						<div class="payment-method-block__body">
							<div class="payment-method-block__right">
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.bank' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[1].name }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.accountNumber' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[1].accountNumber }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.iban' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[1].iban }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.nationalTransfers' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[1].nib }}
								</div>
							</div>
						</div>
					</article>
					-->
				</div>
			</ng-container>
			
			<ng-container *ngIf="market === 'CV'">
				<div class="transfer-accounts__wrapper">
					<article class="payment-method-block" tabindex="0" *ngIf="bankTransferInfo.bankTransferDetails.length > 0 && bankTransferInfo.bankTransferDetails[0]"
						attr.aria-label="{{'bookingPayment.label.transferAccountDetails' | ibeadmin | async}}">
						<div class="payment-method-block__body">
							<div class="payment-method-block__right">
								<div class="payment-method-block__text">
									<b>Escudo Account</b>
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.bank' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].name }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.nib' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].nib }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.iban' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].iban }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.exchangeRate' | ibeadmin | async}}</b>: {{ bankTransferInfo.exchangeRate }}
								</div>
							</div>
						</div>
					</article>
					<div class="vertical-divider" aria-hidden="true" *ngIf="bankTransferInfo.bankTransferDetails.length > 0 && bankTransferInfo.bankTransferDetails[1]">
						<span class="vertical-divider__label">{{'bookingPayment.text.or' | ibeadmin | async}}</span>
					</div>
					<article class="payment-method-block" tabindex="0" *ngIf="bankTransferInfo.bankTransferDetails.length > 0 && bankTransferInfo.bankTransferDetails[1]"
						attr.aria-label="{{'bookingPayment.label.transferAccountDetails' | ibeadmin | async}}">
						<div class="payment-method-block__body">
							<div class="payment-method-block__right">
								<div class="payment-method-block__text">
									<b>Euro Account</b>
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.bank' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[1].name }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.nib' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[1].nib }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.iban' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[1].iban }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.exchangeRate' | ibeadmin | async}}</b>: {{ bankTransferInfo.exchangeRate }}
								</div>
							</div>
						</div>
					</article>
				</div>
			</ng-container>
			
			<ng-container *ngIf="market === 'CI' || market === 'SN' || market === 'TG'">
				<div class="transfer-accounts__wrapper">
					<article class="payment-method-block" tabindex="0" *ngIf="bankTransferInfo.bankTransferDetails.length > 0 && bankTransferInfo.bankTransferDetails[0]"
						attr.aria-label="{{'bookingPayment.label.transferAccountDetails' | ibeadmin | async}}">
						<div class="payment-method-block__body">
							<div class="payment-method-block__right">
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.bank' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].name }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.accountNumber' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].accountNumber }}
								</div>
							</div>
						</div>
					</article>
				</div>
			</ng-container>
			
			<ng-container *ngIf="market === 'GH'">
				<div class="transfer-accounts__wrapper">
					<article class="payment-method-block" tabindex="0" *ngIf="bankTransferInfo.bankTransferDetails.length > 0 && bankTransferInfo.bankTransferDetails[0]"
						attr.aria-label="{{'bookingPayment.label.transferAccountDetails' | ibeadmin | async}}">
						<div class="payment-method-block__body">
							<div class="payment-method-block__right">
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.bank' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].name }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.accountNumberForUSD' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].accountNumber }}
								</div>
								<div class="payment-method-block__text" *ngIf="bankTransferInfo.bankTransferDetails[1]">
									<b>{{'bookingPayment.text.accountNumberForGHS' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[1].accountNumber }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.swift' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].swift }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.exchangeRate' | ibeadmin | async}}</b>: {{ bankTransferInfo.exchangeRate }}
								</div>
							</div>
						</div>
					</article>
				</div>
			</ng-container>
			
			<ng-container *ngIf="market === 'GW'">
				<div class="transfer-accounts__wrapper">
					<article class="payment-method-block" tabindex="0" *ngIf="bankTransferInfo.bankTransferDetails.length > 0 && bankTransferInfo.bankTransferDetails[0]"
						attr.aria-label="{{'bookingPayment.label.transferAccountDetails' | ibeadmin | async}}">
						<div class="payment-method-block__body">
							<div class="payment-method-block__right">
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.bank' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].name }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.accountNumber' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].accountNumber }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.iban' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].iban }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.nationalTransfers' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].nib }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.swift' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].swift }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.bankAddress' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].address }}
								</div>
							</div>
						</div>
					</article>
				</div>
			</ng-container>
			
			<ng-container *ngIf="market === 'ST'">
				<div class="transfer-accounts__wrapper">
					<article class="payment-method-block" tabindex="0" *ngIf="bankTransferInfo.bankTransferDetails.length > 0 && bankTransferInfo.bankTransferDetails[0]"
						attr.aria-label="{{'bookingPayment.label.transferAccountDetails' | ibeadmin | async}}">
						<div class="payment-method-block__body">
							<div class="payment-method-block__right">
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.bank' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].name }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.accountNumber' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].accountNumber }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.nationalTransfers' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].nib }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.swift' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].swift }}
								</div>
								<div class="payment-method-block__text">
									<b>{{'bookingPayment.text.bankAddress' | ibeadmin | async}}</b>: {{ bankTransferInfo.bankTransferDetails[0].address }}
								</div>
							</div>
						</div>
					</article>
				</div>
			</ng-container>

		</section>

		<section class="payment-step-section" attr.aria-label="{{'bookingPayment.label.secondStepProof' | ibeadmin | async}}">
			<h5 class="title-h5 uppercase">
				2. {{'bookingPayment.text.proof' | ibeadmin | async}}
			</h5>
			<p>
				{{'bookingPayment.text.sendProofOfBankTransfer' | ibeadmin | async}} 
				<a class="link" href="mailto:{{ bankTransferInfo.email }}" role="button" 
					attr.aria-label="{{'bookingPayment.label.sendEmailProof' | ibeadmin | async}}">
					{{ bankTransferInfo.email }}
				</a>
			</p>
			<p>
				{{'bookingPayment.text.afterThatReceivedEmail' | ibeadmin | async}}
			</p>
		</section>
	</ng-container>

	<app-notification [style]="'information'" [icon]="'icons.svg#general--timer'"
		[title]="('bookingPayment.text.reservationValidFor' | ibeadmin | async) + numHoursValid + ' ' + ('bookingPayment.text.hours' | ibeadmin | async)">
		<div message>
			<span>
				<!-- Send proof of transfer for the next 72 hours. If you don't, your reservation will be canceled -->
				{{ 'bookingPayment.text.sendBankTransferProofText1' | ibeadmin | async }} {{ numHoursValid }} 
				{{ 'bookingPayment.text.hours' | ibeadmin | async}}. {{ 'bookingPayment.text.sendBankTransferProofText2' | ibeadmin | async }}
			</span>
		</div>
	</app-notification>

	<div class="payment-option__conditions-wrapper top-gap" [class.has-error]="!(formIsValid$ | async)">
		<div class="payment-option__conditions">
			<app-checkbox-input (change)="INDRA_acceptTermsAndConditionsChange($event)" label="" [class.has-error]="!(formIsValid$ | async)"></app-checkbox-input>
			<span>
				{{'bookingPayment.text.haveReadInFullAndAccept' | ibeadmin | async}} 
				<a class="link" href="javascript:;" (click)="INDRA_handleBookingTicketConditions()" 
					attr.aria-label="{{'bookingPayment.aria.openFare' | ibeadmin | async}}" role="button">
					{{'bookingPayment.text.fareConditions' | ibeadmin | async}}
				</a> 
				{{'bookingPayment.text.andThe' | ibeadmin | async}} 
				<a class="link link--external" href="javascript:;"
					(click)="INDRA_gotoURL('externalURLs.transportConditions')"
					attr.aria-label="{{'bookingPayment.text.conditionsOfCarriage' | ibeadmin | async}}">
					{{'bookingPayment.text.tncCarriage' | ibeadmin | async}}
				</a> 
				<!--{{'bookingPayment.text.andThe' | ibeadmin | async}}
				<a class="link link--external" href="javascript:;"
					(click)="INDRA_gotoURL('externalURLs.milesGoTermsConditions')">
					{{'bookingPayment.text.conditionsOfMilesGoProgramme' | ibeadmin | async}}
				</a>-->
				<ng-container *ngIf="displayCovidTermsAndCondition">
					, {{ 'bookingPayment.text.andAcceptCovidCondition' | ibeadmin | async }}
					<a class="link link--external" href="javascript:;"
						(click)="INDRA_gotoURL('externalURLs.canadaTravelMeasures')">
						{{ 'bookingPayment.text.termsConditions' | ibeadmin | async }}
					</a>
					{{ 'bookingPayment.text.covidCondition' | ibeadmin | async }}
				</ng-container>
			</span>
		</div>
	</div>
</div>
